import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import moment from 'moment';
import 'moment/locale/de'

class SeasonSelector extends Component {
    static propTypes = {
        actions: PropTypes.object.isRequired,
    };

    handleChange(event, sp) {
        this.props.actions.setCurrentSeason(event.target.value);
    }

    render() {
        return <div style={{ display:"inline-block"}}>
         <Select
          value={this.props.currentSeasonId}
          onChange={this.handleChange.bind(this)}
          inputProps={{
            name: 'season',
            id: 'season',
          }}
        >
            {Object.keys(this.props.seasons).map(sId => 
            <MenuItem value={sId}>{moment.utc(this.props.seasons[sId].from).format("DD.MM.YYYY")} - {moment.utc(this.props.seasons[sId].to).format("DD.MM.YYYY")}</MenuItem>)}
        </Select>
        </div>;
    }


}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
      seasons: state.home.seasons,
      currentSeasonId: state.home.currentSeasonId,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeasonSelector);



// WEBPACK FOOTER //
// ./src/features/home/SeasonSelector.js